import {context} from 'vue3-starter/src/typescript/app-context/AppContext';
import {BlockedCountriesList} from '@/common/repositories/blocked-countries/BlockedCountriesList';

type BlockedCountry = {

    countryCode: string;
};
type BlockedCountriesResponse = {
    countries: BlockedCountry[];
};

export class BlockedCountryRepository {
    async getAll(): Promise<BlockedCountriesList> {
        const [response] = await context.httpService.get(context.registry.entries.blockedCountries());
        return (response as BlockedCountriesResponse).countries.map((c: BlockedCountry) => c.countryCode);
    }
}

